// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bd597f1c","682":"f5dbc509"}[chunkId] + ".chunk.js";
};